// Modo de visualização do dashboard: 'live' (Produção) ou 'test' (Sandbox).
// Guardado no localStorage para o interceptor do axios enviar no header X-Gpo-Mode.

export const MODE_STORAGE_KEY = 'gpo_mode';
export const MODE_FORCED_EVENT = 'gpo:mode-forced';

export const readStoredMode = () => {
  try {
    const value = window.localStorage.getItem(MODE_STORAGE_KEY);
    return value === 'live' || value === 'test' ? value : null;
  } catch {
    return null;
  }
};

export const writeStoredMode = (mode) => {
  try {
    if (mode) {
      window.localStorage.setItem(MODE_STORAGE_KEY, mode);
    } else {
      window.localStorage.removeItem(MODE_STORAGE_KEY);
    }
  } catch {
    // localStorage indisponível: o backend usa o modo padrão da conta
  }
};
